<template>
  <div class="SearchDalog">
    <el-dialog
      :title="searchData.title"
      width="30%"
      append-to-body
      :visible.sync="visible"
      @close="$emit('update:show', false)"
      :show="show"
    >
      <div class="content_box">
        <Tree :treeData="treeData" @clickTree="clickTree" ref="treecomponent" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="saveInfor">保 存</el-button>
          <el-button size="mini" @click="canlse">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
import tool from "@/utils/tool"; //本地缓存存取

export default {
  data() {
    return {
      visible: this.show, //是否显示弹出框
      treeData: [], //树状图数据
      classVal: { FullName: "", KtypeId: Number } //当前仓库的分类值
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fieldData: String,
    searchData: Object
  },
  methods: {
    // 请求树状图数据
    InitTree() {
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        style:this.$attrs.pargam.style,//1-供应商,0-客户
      };
      // console.log(params, this.searchData);

      this.request
        .post(this.searchData.url, { jparams: JSON.stringify(params) })
        .then(res => {
          // 接收后端发送回来的数据
          // console.log(res)
          this.treeData = res.tree;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 点击树状图节点
    clickTree(data) {
      this.classVal.FullName = data.label;
      this.classVal.KtypeId = data.id;
    },
    //保存
    saveInfor() {
      this.$emit("dateChange", this.classVal, this.fieldData);
      this.canlse();
    },
    canlse() {
      // this.classVal = {FullName:'',KtypeId:Number};//当前仓库的分类值
      this.visible = false;
    }
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.visible) {
        this.InitTree();
      }
    }
  },
  // 创建生命周期钩子函数
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
    // 初始化数据
    this.InitTree();
  }
};
</script>

<style lang="less">
.el-dialog__header {
  background: rebeccapurple;
  // background: #4990d7;
  padding: 10px 10px 0;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px;
}
.content_box {
  .dialog-footer {
    width: 100%;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-pack: end;
    box-pack: end;
    margin: 20px 0 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/ClassificationDialog/ClassificationDialog.vue